import React, { useEffect, useState } from "react";
import { Card, Row, Col, Spin, Alert } from "antd";
import { CalendarFilled } from "@ant-design/icons";
import API from "api/endpoints";
import axiosInstance from "api/axiosInstance";
import colors from "assets/theme/base/colors";

function UpComingHolidays() {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch holidays from API
  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await axiosInstance.get(API.holiday.getList);

        if (Array.isArray(response.data)) {
          // Sort holidays by month and day
          const sorted = [...response.data].sort((a, b) => {
            if (a.month === b.month) return a.day - b.day;
            return a.month - b.month;
          });
          setHolidays(sorted);
        } else {
          throw new Error("Invalid API response format");
        }
      } catch (err) {
        console.error("❌ Failed to load holidays:", err);
        setError("Unable to load holidays. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchHolidays();
  }, []);

  return (
    <Card title="Upcoming Holidays" className="card-professional">
      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <Spin />
        </div>
      ) : error ? (
        <Alert message={error} type="error" showIcon />
      ) : (
        <div className="holiday-list">
          {holidays.length > 0 ? (
            holidays.map((holiday) => (
              <Row key={holiday.id} gutter={16} style={{ marginBottom: "16px" }}>
                <Col span={24}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <CalendarFilled
                      style={{ fontSize: "36px", color: colors.primary.main, marginRight: "8px" }}
                    />
                    <div>
                      <p style={{ margin: 0, fontWeight: "500" }}>{holiday.name}</p>
                      <p style={{ margin: 0, color: "#888" }}>
                        {new Date(holiday.fromDate).toLocaleDateString("en-US", {
                          weekday: "long",
                          month: "long",
                          day: "numeric",
                        })}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            ))
          ) : (
            <p style={{ textAlign: "center", color: "#888" }}>No upcoming holidays found.</p>
          )}
        </div>
      )}
    </Card>
  );
}

export default UpComingHolidays;
